import { updatePictogramEntities as updatePictogramEntitiesApi,
  reversePictogramEntities as reversePictogramEntitiesApi
} from '../api/pictogram-entities.api';

const processCompleteAction = (data, modifiedEntities, typeRegister) => {
  const updatedEntities = [...modifiedEntities];

  data.changeEntities.forEach((item, i) => {
    let indexEntity = updatedEntities.findIndex(
      (obj) => { return parseInt(obj.id) === parseInt(item.picId) }
    );

    if (indexEntity !== -1) {
      // Actualizamos entidad existente
      if (typeRegister === 'progress') {
        updatedEntities[indexEntity].status = typeof item.picStatus === 'object'
          ? item.picStatus.id
          : item.picStatus;

        // Validar que selectedStatus sea un array antes de usar map
        updatedEntities[indexEntity].statuses = Array.isArray(data.selectedStatus)
          ? data.selectedStatus.map(status => { return { id: status.id, type: status.type } })
          : [{ id: data.selectedStatus.id, type: data.selectedStatus.type }];

      } else { // typeRegister === 'issue'
        updatedEntities[indexEntity].withIssue = item.picWithIssue;
      }
    } else { // Entidad no encontrada, la agregamos
      let objEntity = {
        id: item.picId,
        name: item.picName,
        type: item.picType,
        layer: item.picLayerName,
      }

      if (typeRegister === 'progress') {
        objEntity.previou_status = item.picPreviouStatus // estado anterior
        objEntity.status = (item.picStatus != null && typeof item.picStatus === 'object') ? item.picStatus.id : item.picStatus
        // Validar que selectedStatus sea un array antes de usar map
        objEntity.statuses = Array.isArray(data.selectedStatus)
          ? data.selectedStatus.map(status => { return { id: status.id, type: status.type } })
          : [{ id: data.selectedStatus.id, type: data.selectedStatus.type }];
      } else { // typeRegister === 'issue'
        objEntity.withIssue = item.picWithIssue;
      }

      updatedEntities.push(objEntity);
    }
  });

  return {
    updatedEntities: updatedEntities,
    typeStatus: data.typeStatus,
    startDate: data.start_date,
    endDate: data.end_date,
  };
};

const updatePictogramEntities = async (pictogramId, modifiedEntities, workLayer) => {
  let payload = new FormData();
  payload.append('modified_entities', JSON.stringify(modifiedEntities))
  payload.append('work_layer', workLayer)

  const response = await updatePictogramEntitiesApi(pictogramId, payload);

  return response.data;
};

const reversePictogramEntities = async (pictogramId, action, typeStatus, selectedEntities, workLayer) => {
  let payload = new FormData();
  payload.append('action', action);
  payload.append('type_status', typeStatus);
  payload.append('selected_entities', JSON.stringify(selectedEntities))
  payload.append('work_layer', workLayer)

  try {
    const response = await reversePictogramEntitiesApi(pictogramId, payload);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 422) {
      error.error_msg = error.response.data.errors[
        Object.keys(error.response.data.errors)[0]
      ][0];
    }
    throw error;
  }
};

const extractDataEntities = (entities) => {
  if (!entities || !Array.isArray(entities)) {
    return [];
  }
  return entities.map((item) => ({
    id: item.picId,
    type: item.picType,
  }));
};

export {
  processCompleteAction,
  extractDataEntities,
  updatePictogramEntities,
  reversePictogramEntities,
}
